import React, {useState, useRef, useEffect, useContext} from 'react';
import clsx from 'clsx';
import {
    makeStyles,
    AppBar,
    IconButton,
    Toolbar,
    Typography,
    Avatar,
} from '@material-ui/core';
import UserPopover from "./components/UserPopover";
import {AccountCircle} from "@material-ui/icons";
import {GlobalContext} from "../../../../contexts/context";

const useStyles = makeStyles(theme => ({
    root: {},
    flexGrow: {
        flexGrow: 1
    },
    headText: {
        color: "#FFF",
    },
    avatar: {
        color: "#FFF",
        backgroundColor: theme.palette.primary.light
    },
    logo: {
        maxHeight: 50,
    },
    userLogo: {
        maxHeight: 50,
        marginRight: 10
    }
}));


const TopBar = ({className}) => {
    const classes = useStyles();
    const [openUser, setOpenUser] = useState(false);
    const accountRef = useRef(null);
    const context = useContext(GlobalContext);

    const handleOpenUser = () => {
        setOpenUser(true);
    };

    const handleCloseUser = () => {
        setOpenUser(false);
    };

    return (
        <AppBar
            className={clsx(classes.root, className)}
            color="primary"
        >
            <Toolbar>
                <img
                    className={classes.logo}
                    alt="Logo"
                    src="/images/ltklogo.png"/>
                <div className={classes.flexGrow}/>
                {
                    context.user.verified &&
                    <>
                    {/*<img*/}
                    {/*    className={classes.userLogo}*/}
                    {/*    alt="Logo"*/}
                    {/*    src={context.applicationState.logoUrl}/>*/}
                    <IconButton
                        color="inherit"
                        onClick={handleOpenUser}
                        ref={accountRef}
                    >

                            <AccountCircle/>

                    </IconButton>
                    </>
                }
            </Toolbar>
            {
                openUser &&
                    <UserPopover
                        anchorEl={accountRef.current}
                        onClose={handleCloseUser}
                        handleClose={handleCloseUser}
                        open={openUser}
                    />
            }
        </AppBar>

    )
};

export default TopBar;
